export enum FullUrl {
  Lumio = "https://lumio.liquidswap.com/#/",
  LiquidSwap = "https://liquidswap.com/",
  Movement = "https://movement.liquidswap.com/",
}
